import { render, staticRenderFns } from "./OpsWallClip.vue?vue&type=template&id=549bc8ce&scoped=true"
import script from "./OpsWallClip.vue?vue&type=script&lang=js"
export * from "./OpsWallClip.vue?vue&type=script&lang=js"
import style0 from "./OpsWallClip.vue?vue&type=style&index=0&id=549bc8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549bc8ce",
  null
  
)

export default component.exports